export default function Badge({ children, variant = 'default' }) {
  const variants = {
    default: 'bg-subtle text-body',
    success: 'bg-positive-soft text-positive',
    warning: 'bg-warning-soft text-warn',
    danger: 'bg-negative-soft text-negative',
    info: 'bg-secondary-soft text-secondary',
  }

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]}`}>
      {children}
    </span>
  )
}
